export default __webpack_public_path__ + "audio/calling_outgoing.mp3";